module.exports = __webpack_public_path__ + "static/full3-2f252617f6cbbfdc0c91f4c2b28bbdc5.png";